import { Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

import { Typography } from "@/components/ui/typography";
import { cn } from "@/lib/utils";

type LineChartComponentProps = {
  data: unknown[];
  dataKey: string;
  title: string;
  className?: string;
  lines: Array<{
    lineDataKey: string;
    lineName: string;
    color: string;
  }>;
};
export default function LineChartComponent({ data, dataKey, lines, className, title }: LineChartComponentProps) {
  return (
    <div className={cn("w-full rounded-md bg-white p-4 text-black shadow-md md:w-[45%]", className)}>
      <Typography className="mb-4 text-black" variant="text-lg" weight="semibold">
        {title}
      </Typography>
      <ResponsiveContainer width="100%" height={350}>
        <LineChart data={data}>
          <XAxis
            dataKey={dataKey}
            angle={-45}
            textAnchor="end"
            interval={0}
            height={60}
            tickFormatter={(value) => (value.length > 10 ? `${value.slice(0, 10)}...` : value)}
            tick={{ fontSize: 10 }}
          />
          <YAxis
            width={80}
            tickFormatter={(value) => (value.length > 6 ? `${value.slice(0, 6)}...` : value)}
            tick={CustomXAxisTick}
          />
          <Tooltip formatter={(value, name) => [`${name}: ${value}`]} />
          <Legend verticalAlign="top" height={36} />
          {lines.map((l) => (
            <Line key={l.lineName} type="monotone" dataKey={l.lineDataKey} name={l.lineName} stroke={l.color} />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

const CustomXAxisTick = ({ x, y, payload }: any) => {
  return (
    <g transform={`translate(${x},${y})`}>
      <title>{payload.value}</title> {/* Full label on hover */}
      <text x={0} y={0} dy={10} textAnchor="end" fontSize={10}>
        {payload.value.length > 9 ? `${payload.value.slice(0, 9)}...` : payload.value}
      </text>
    </g>
  );
};
